/* v2-compact-upsell */
/* MedBedStoreManus - Global JavaScript */

document.addEventListener('DOMContentLoaded', function() {
  // Header scroll effect
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 50);
    });
  }

  // Mobile menu toggle
  var mobileToggle = document.querySelector('.header-mobile-toggle');
  var mobileMenu = document.querySelector('.mobile-menu');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function() {
      mobileMenu.classList.toggle('open');
    });
  }

  // FAQ accordion
  document.querySelectorAll('.faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.faq-item');
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
      if (!wasOpen) item.classList.add('open');
    });
  });

  // Pack selector
  document.querySelectorAll('.pack-option').forEach(function(option) {
    option.addEventListener('click', function() {
      var selector = this.closest('.pack-selector');
      selector.querySelectorAll('.pack-option').forEach(function(o) { o.classList.remove('active'); });
      this.classList.add('active');
      var variantId = this.dataset.variantId;
      var packQty = this.dataset.quantity;
      if (variantId) {
        var form = this.closest('form') || document.querySelector('form[action*="cart"]');
        if (form) {
          var input = form.querySelector('input[name="id"]');
          if (input) input.value = variantId;
          // Quantity always stays at 1 — each variant already represents the full pack
          var qtyInput = form.querySelector('input[name="quantity"]');
          if (qtyInput) qtyInput.value = '1';
        }
      }
      // Selling plan removed - Recovery Gel is now one-time purchase only
      // Update cart price display
      var priceDisplay = document.querySelector('.cart-price-display');
      if (priceDisplay && variantId) {
        var allOptions = selector.querySelectorAll('.pack-option');
        var priceEl = this.querySelector('.pack-price');
        if (priceEl) priceDisplay.textContent = priceEl.textContent;
      }
    });
  });

  // Sync variant ID on page load to match the visually active pack option
  (function() {
    var activeOption = document.querySelector('.pack-option.active');
    if (activeOption) {
      var variantId = activeOption.dataset.variantId;
      if (variantId) {
        var form = activeOption.closest('form') || document.querySelector('form[action*="cart"]');
        if (form) {
          var input = form.querySelector('input[name="id"]');
          if (input) input.value = variantId;
        }
        // Also update price display
        var priceDisplay = document.querySelector('.cart-price-display');
        var priceEl = activeOption.querySelector('.pack-price');
        if (priceDisplay && priceEl) priceDisplay.textContent = priceEl.textContent;
      }
    }
  })();

  // Product image gallery
  document.querySelectorAll('.product-thumbnail').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var mainImage = document.querySelector('.product-main-image img');
      if (mainImage) {
        mainImage.src = this.dataset.src || this.querySelector('img').src;
        document.querySelectorAll('.product-thumbnail').forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
      }
    });
  });

  // Intersection observer for scroll animations
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('[data-animate]').forEach(function(el) {
    observer.observe(el);
  });

  // ==========================================
  // CART SIDEBAR
  // ==========================================
  var cartOverlay = document.getElementById('cart-overlay');
  var cartSidebar = document.getElementById('cart-sidebar');
  var cartCloseBtn = document.getElementById('cart-sidebar-close');
  var cartTimerEl = document.getElementById('cart-timer');
  var cartTimerInterval = null;

  function openCart() {
    if (cartOverlay) cartOverlay.classList.add('active');
    if (cartSidebar) cartSidebar.classList.add('active'); window.__cartOpen = true;
    /* Close ALL congratulations/discount popups when cart opens */
    ['rgCongratsOverlay','rgDiscountOverlay','icCongratsOverlay','icDiscountOverlay','mbtCongratsOverlay','mbtDiscountOverlay'].forEach(function(id){
      var el = document.getElementById(id);
      if(el){ el.style.setProperty('display','none','important'); el.classList.remove('active'); el.style.setProperty('opacity','0','important'); el.style.setProperty('visibility','hidden','important'); el.style.setProperty('pointer-events','none','important'); el.style.setProperty('z-index','-1','important'); }
    });
    ['icGiftBtn','mbtGiftBtn','rgGiftBtn'].forEach(function(id){
      var el = document.getElementById(id);
      if(el){ el.style.setProperty('display','none','important'); }
    });
    document.body.style.overflow = 'hidden';
    startCartTimer();
  }

  function closeCart() {
    if (cartOverlay) cartOverlay.classList.remove('active');
    if (cartSidebar) cartSidebar.classList.remove('active'); window.__cartOpen = false;
    document.body.style.overflow = '';
  }

  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // Cart icon in header redirects to checkout
  document.querySelectorAll('a[href="/cart"], .header-cart-link').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      window.location.href = '/checkout';
    });
  });

  // Cart timer
  function startCartTimer() {
    if (cartTimerInterval) clearInterval(cartTimerInterval);
    var cartExpiry = sessionStorage.getItem('medbed_cart_expiry');
    if (!cartExpiry) {
      cartExpiry = Date.now() + 10 * 60 * 1000;
      sessionStorage.setItem('medbed_cart_expiry', cartExpiry.toString());
    }
    function updateCartTimer() {
      var remaining = parseInt(sessionStorage.getItem('medbed_cart_expiry')) - Date.now();
      if (remaining <= 0) {
        if (cartTimerEl) cartTimerEl.textContent = '00:00';
        clearInterval(cartTimerInterval);
        return;
      }
      var mins = Math.floor(remaining / 60000);
      var secs = Math.floor((remaining % 60000) / 1000);
      if (cartTimerEl) cartTimerEl.textContent = String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0');
    }
    updateCartTimer();
    cartTimerInterval = setInterval(updateCartTimer, 1000);
  }

  // Fetch cart and render
  function fetchAndRenderCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCart(cart); })
      .catch(function(err) { console.error('Cart fetch error:', err); });
  }

  // Product data for savings calculations
  var productSavingsData = {
    'medbed-therapy': { '1 Pack': { compare: 990000, price: 349000 }, '2 Pack': { compare: 1490000, price: 499000 }, 'Standard': { compare: 990000, price: 349000 }, 'Premium': { compare: 1490000, price: 499000 } },
    'ioniccarex': { '1 Pack': { compare: 249000, price: 69900 }, '2 Pack': { compare: 498000, price: 99000 }, '3 Pack': { compare: 747000, price: 139000 } },
    'ionic-care': { '1 Pack': { compare: 249000, price: 69900 }, '2 Pack': { compare: 498000, price: 99000 }, '3 Pack': { compare: 747000, price: 139000 } },
    'medbed-card': { '1 Card': { compare: 59900, price: 19900 }, '5 Cards': { compare: 299500, price: 49900 }, '10 Cards': { compare: 599000, price: 79900 } },
    'medbed-recovery-gel': { '1 Pack': { compare: 49900, price: 7900 }, '3 Pack': { compare: 149700, price: 20700 }, '6 Pack': { compare: 299400, price: 35400 } },
    'recovery-gel': { '1 Pack': { compare: 49900, price: 7900 }, '3 Pack': { compare: 149700, price: 20700 }, '6 Pack': { compare: 299400, price: 35400 } },
    'medbed-recovery-special': { '1 Pack': { compare: 49900, price: 6300 }, '3 Pack': { compare: 149700, price: 16600 }, '6 Pack': { compare: 299400, price: 28400 } }
  };

  function renderCart(cart) {
    var itemsContainer = document.getElementById('cart-items');
    var emptyContainer = document.getElementById('cart-empty');
    var countEl = document.getElementById('cart-sidebar-count');
    var totalEl = document.getElementById('cart-total');
    var savingsEl = document.getElementById('cart-savings');
    var checkoutBtn = document.getElementById('cart-checkout-btn');
    var protectionEl = document.getElementById('cart-shipping-protection');
    var summaryEl = document.getElementById('cart-summary');
    var timerBar = document.getElementById('cart-timer-bar');
    var shippingProgress = document.querySelector('.cart-shipping-progress');

    if (!itemsContainer) return;

    var itemCount = cart.item_count || 0;
    var hasRecoveryGel = false;
    var hasQualifyingProduct = false;

    if (countEl) countEl.textContent = '(' + itemCount + ' item' + (itemCount !== 1 ? 's' : '') + ')';

    if (itemCount === 0) {
      itemsContainer.innerHTML = '';
      if (emptyContainer) emptyContainer.style.display = 'block';
      if (protectionEl) protectionEl.style.display = 'none';
      if (summaryEl) summaryEl.style.display = 'none';
      if (checkoutBtn) checkoutBtn.style.display = 'none';
      if (timerBar) timerBar.style.display = 'none';
      if (shippingProgress) shippingProgress.style.display = 'none';
      return;
    }

    if (emptyContainer) emptyContainer.style.display = 'none';
    if (protectionEl) protectionEl.style.display = 'flex';
    if (summaryEl) summaryEl.style.display = 'block';
    if (checkoutBtn) checkoutBtn.style.display = 'flex';
    if (timerBar) timerBar.style.display = 'flex';
    if (shippingProgress) shippingProgress.style.display = 'block';

    var totalSavings = 0;
    var html = '';

    // Sort items: non-subscription first, subscription last
    cart.items.sort(function(a, b) {
      var aIsSub = a.selling_plan_allocation ? 1 : 0;
      var bIsSub = b.selling_plan_allocation ? 1 : 0;
      return aIsSub - bIsSub;
    });

    cart.items.forEach(function(item) {
      var isGel = item.product_title.toLowerCase().indexOf('recovery gel') > -1 || item.product_title.toLowerCase().indexOf('gel') > -1;
      if (isGel) hasRecoveryGel = true;
      // Check if this is a qualifying product (Ionic Care or MedBed Therapy)
      var pTitle = item.product_title.toLowerCase();
      if (pTitle.indexOf('ionic care') > -1 || (pTitle.indexOf('medbed therapy') > -1 && pTitle.indexOf('gel') === -1)) {
        hasQualifyingProduct = true;
      }

      // Calculate savings using productSavingsData lookup
      var saved = 0;
      var handle = item.handle || '';
      var variantTitle = item.variant_title || 'Default Title';
      if (productSavingsData[handle] && productSavingsData[handle][variantTitle]) {
        var psd = productSavingsData[handle][variantTitle];
        if (psd.compare > psd.price) {
          saved = (psd.compare - psd.price) * item.quantity;
        }
      } else {
        // Fallback to Shopify's original_line_price
        var comparePrice = item.original_line_price || item.line_price;
        saved = comparePrice - item.line_price;
        if (saved < 0) saved = 0;
      }
      totalSavings += saved;

      var imgSrc = item.image ? item.image.replace(/(\.\.w+)(\?|$)/, '_180x$1$2') : '';
      if (!imgSrc && item.featured_image && item.featured_image.url) imgSrc = item.featured_image.url;
      // Override image for Recovery Gel to use new jar image
      if (handle === 'medbed-recovery-gel' || handle === 'medbed-recovery-special') imgSrc = 'https://files.manuscdn.com/user_upload_by_module/session_file/310519663307727868/FsVPKRbtdDZIVRhk.png';
      html += '<div class="cart-item" data-key="' + item.key + '">';
      html += '  <img class="cart-item-image" src="' + (imgSrc || '') + '" alt="' + item.product_title + '">';
      html += '  <div class="cart-item-info">';
      html += '    <p class="cart-item-name">' + item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' \u2014 ' + item.variant_title : '') + '</p>';

      if (isGel && item.selling_plan_allocation) {
        html += '    <div style="display:flex;align-items:center;justify-content:space-between;">';
        html += '      <!--<div class="cart-item-subscription"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg> SUBSCRIPTION</div> -->';
        html += '      <div class="cart-item-subscription" style="white-space:nowrap;font-size:0.65rem;padding:3px 8px;"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg> Exclusive Offer only today</div>';
        html += '      <button class="cart-item-remove" onclick="updateCartItem(\'' + item.key + '\', 0)" title="Remove">&times;</button>';
        html += '    </div>';
        html += '    <p class="cart-item-sub-details">1st Month FREE, then $139/mo</p>';
        html += '    <span class="cart-item-sub-cancel">Cancel anytime</span>';
        html += '    <div id="sub-countdown" style="margin-top:6px;display:flex;align-items:center;gap:6px;font-size:0.75rem;color:#ef4444;font-weight:600;"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg> <span>Offer expires in </span><span id="sub-countdown-timer" style="font-variant-numeric:tabular-nums;">15:00</span></div>';
      } else if (isGel && !item.selling_plan_allocation) {
        // One-time gel purchase - show normal qty controls
        html += '    <div class="cart-item-qty-row">';
        html += '      <div class="cart-item-qty">';
        html += '        <button onclick="updateCartItem(\'' + item.key + '\', ' + (item.quantity - 1) + ')">&minus;</button>';
        html += '        <span>' + item.quantity + '</span>';
        html += '        <button onclick="updateCartItem(\'' + item.key + '\', ' + (item.quantity + 1) + ')">+</button>';
        html += '      </div>';
        html += '      <button class="cart-item-remove" onclick="updateCartItem(\'' + item.key + '\', 0)" title="Remove">&times;</button>';
        html += '    </div>';
      } else {
        html += '    <div class="cart-item-qty-row">';
        html += '      <div class="cart-item-qty">';
        html += '        <button onclick="updateCartItem(\'' + item.key + '\', ' + (item.quantity - 1) + ')">&minus;</button>';
        html += '        <span>' + item.quantity + '</span>';
        html += '        <button onclick="updateCartItem(\'' + item.key + '\', ' + (item.quantity + 1) + ')">+</button>';
        html += '      </div>';
        html += '      <button class="cart-item-remove" onclick="updateCartItem(\'' + item.key + '\', 0)" title="Remove">&times;</button>';
        html += '    </div>';
      }

      html += '  </div>';
      html += '  <div class="cart-item-prices">';

      if (isGel && item.selling_plan_allocation) {
        // Subscription gel without qualifying product - show actual subscription price
        html += '    <p class="cart-item-price">' + formatMoney(item.line_price) + '</p>';
        var planName = item.selling_plan_allocation.selling_plan.name || '';
        html += '    <p class="cart-item-sub-details" style="font-size:0.65rem;color:var(--gray-400);">' + planName + '</p>';
      } else if (isGel && !item.selling_plan_allocation) {
        // One-time gel purchase - show normal price
        if (comparePrice > item.line_price) {
          html += '    <p class="cart-item-original">' + formatMoney(comparePrice) + '</p>';
        }
        html += '    <p class="cart-item-price">' + formatMoney(item.line_price) + '</p>';
        if (saved > 0) {
          html += '    <p class="cart-item-saved">Saved ' + formatMoney(saved) + '</p>';
        }
      } else {
        if (comparePrice > item.line_price) {
          html += '    <p class="cart-item-original">' + formatMoney(comparePrice) + '</p>';
        }
        html += '    <p class="cart-item-price">' + formatMoney(item.line_price) + '</p>';
        if (saved > 0) {
          html += '    <p class="cart-item-saved">Saved ' + formatMoney(saved) + '</p>';
        }
      }

      html += '  </div>';
      html += '</div>';
    });

    // Auto-remove subscription gel if no qualifying products in cart
    var hasSubscriptionGel = false;
    var subscriptionGelKey = null;
    var subscriptionItems = [];
    var hasQualifyingNonSubProduct = false;
    cart.items.forEach(function(item) {
      var pTitle = item.product_title.toLowerCase();
      var isSubItem = item.selling_plan_allocation;
      var isSubGel = (pTitle.indexOf('recovery gel') > -1 || pTitle.indexOf('gel') > -1) && isSubItem;
      if (isSubItem) {
        subscriptionItems.push(item);
      }
      if (isSubGel) {
        hasSubscriptionGel = true;
        subscriptionGelKey = item.key;
      }
      var isIonicCare = pTitle.indexOf('ionic care') > -1;
      var isTherapy = pTitle.indexOf('medbed therapy') > -1 || (pTitle.indexOf('therapy') > -1 && pTitle.indexOf('gel') === -1);
      var isGelNonSub = (pTitle.indexOf('recovery gel') > -1 || pTitle.indexOf('gel') > -1) && !item.selling_plan_allocation;
      if (isIonicCare || isTherapy || isGelNonSub) {
        hasQualifyingNonSubProduct = true;
      }
    });

    // Enforce max 1 subscription item in cart - remove duplicates
    if (subscriptionItems.length > 1) {
      var toRemove = subscriptionItems.slice(1); // keep first, remove rest
      var removePromise = Promise.resolve();
      toRemove.forEach(function(subItem) {
        removePromise = removePromise.then(function() {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: subItem.key, quantity: 0 })
          }).then(function(r) { return r.json(); });
        });
      });
      removePromise.then(function(updatedCart) {
        renderCart(updatedCart);
        updateHeaderCartCount(updatedCart.item_count);
      });
      return;
    }

    if (hasSubscriptionGel && !hasQualifyingNonSubProduct) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: subscriptionGelKey, quantity: 0 })
      })
      .then(function(r) { return r.json(); })
      .then(function(updatedCart) {
        renderCart(updatedCart);
        updateHeaderCartCount(updatedCart.item_count);
      });
      return;
    }
    itemsContainer.innerHTML = html;

    // Check shipping protection toggle
    var spToggle = document.getElementById('sp-toggle-input');
    var spCost = 0; // Shipping protection is FREE - included in price
    var finalTotal = cart.total_price + spCost;

    if (totalEl) totalEl.textContent = formatMoney(finalTotal);
    if (savingsEl) savingsEl.textContent = formatMoney(totalSavings);

    
    // === Ionic Care Upsell Logic ===
    var icUpsellEl = document.getElementById('ic-cart-upsell');
    if (icUpsellEl) {
      var hasGelInCart = false;
      var hasIonicCareInCart = false;
      cart.items.forEach(function(item) {
        var t = item.product_title.toLowerCase();
        if (t.indexOf('recovery gel') > -1 || t.indexOf('gel') > -1) hasGelInCart = true;
        if (t.indexOf('ionic care') > -1) hasIonicCareInCart = true;
      });
      // Show upsell only when Recovery Gel is in cart and Ionic Care is NOT
      if (hasGelInCart && !hasIonicCareInCart) {
        icUpsellEl.style.display = 'block';
        // Start 15-min timer
        var icTimerKey = 'medbed_ic_upsell_expiry';
        var icExp = sessionStorage.getItem(icTimerKey);
        if (!icExp || parseInt(icExp) < Date.now()) {
          icExp = (Date.now() + 15 * 60 * 1000).toString();
          sessionStorage.setItem(icTimerKey, icExp);
        }
        if (window._icUpsellInterval) clearInterval(window._icUpsellInterval);
        window._icUpsellInterval = setInterval(function() {
          var timerEl = document.getElementById('ic-upsell-timer');
          if (!timerEl) { clearInterval(window._icUpsellInterval); return; }
          var remaining = parseInt(sessionStorage.getItem(icTimerKey)) - Date.now();
          if (remaining <= 0) {
            timerEl.textContent = '0:00';
            clearInterval(window._icUpsellInterval);
            // Hide upsell when expired
            var upsell = document.getElementById('ic-cart-upsell');
            if (upsell) upsell.style.display = 'none';
            return;
          }
          var mins = Math.floor(remaining / 60000);
          var secs = Math.floor((remaining % 60000) / 1000);
          timerEl.textContent = mins + ':' + (secs < 10 ? '0' : '') + secs;
        }, 1000);
      } else {
        icUpsellEl.style.display = 'none';
      }
    }

    // Start subscription countdown timer (15 minutes)
    var subTimerEl = document.getElementById('sub-countdown-timer');
    if (subTimerEl) {
      var subExpKey = 'medbed_sub_offer_expiry';
      var subExp = sessionStorage.getItem(subExpKey);
      if (!subExp || parseInt(subExp) < Date.now()) {
        subExp = (Date.now() + 15 * 60 * 1000).toString();
        sessionStorage.setItem(subExpKey, subExp);
      }
      if (window._subCountdownInterval) clearInterval(window._subCountdownInterval);
      window._subCountdownInterval = setInterval(function() {
        var timerEl = document.getElementById('sub-countdown-timer');
        if (!timerEl) { clearInterval(window._subCountdownInterval); return; }
        var remaining = parseInt(sessionStorage.getItem(subExpKey)) - Date.now();
        if (remaining <= 0) {
          timerEl.textContent = '0:00';
          clearInterval(window._subCountdownInterval);
          return;
        }
        var mins = Math.floor(remaining / 60000);
        var secs = Math.floor((remaining % 60000) / 1000);
        timerEl.textContent = mins + ':' + (secs < 10 ? '0' : '') + secs;
      }, 1000);
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Update cart item quantity
  window.updateCartItem = function(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      renderCart(cart);
      updateHeaderCartCount(cart.item_count);
    });
  };

  
  // Add Ionic Care upsell to cart
  window.addIonicCareUpsell = function() {
    var btn = document.getElementById('ic-upsell-add-btn');
    if (btn) {
      btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="spin-icon"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg> ADDING...';
      btn.style.pointerEvents = 'none';
    }
    
    /* Dismiss all popups immediately on add-to-cart */
    window.__cartOpen = true;
    ['rgCongratsOverlay','rgDiscountOverlay','icCongratsOverlay','icDiscountOverlay','mbtCongratsOverlay','mbtDiscountOverlay'].forEach(function(id){
      var el = document.getElementById(id);
      if(el){ el.style.setProperty('display','none','important'); el.classList.remove('active'); el.style.setProperty('opacity','0','important'); el.style.setProperty('visibility','hidden','important'); el.style.setProperty('pointer-events','none','important'); }
    });
    /* Also hide gift buttons */
    ['icGiftBtn','mbtGiftBtn','rgGiftBtn'].forEach(function(id){
      var el = document.getElementById(id);
      if(el){ el.style.display='none'; }
    });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: 50071072309494, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      if (btn) {
        btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> ADDED!';
        btn.classList.add('added');
      }
      fetchAndRenderCart();
    })
    .catch(function(err) {
      console.error('Upsell add error:', err);
      if (btn) {
        btn.innerHTML = 'ADD';
        btn.style.pointerEvents = 'auto';
      }
    });
  };

  function updateHeaderCartCount(count) {
    document.querySelectorAll('.header-cart-count, a[href="/cart"] .cart-count, a[href="/cart"]').forEach(function(el) {
      if (el.querySelector('.cart-count')) {
        el.querySelector('.cart-count').textContent = count;
      } else if (el.classList.contains('header-cart-link') || el.getAttribute('href') === '/cart') {
        // Update the cart icon badge
        var badge = el.querySelector('span');
        if (badge) badge.textContent = count;
      }
    });
  }

  // Override checkout button to add gel before redirecting
  var checkoutBtnEl = document.getElementById('cart-checkout-btn');
  if (checkoutBtnEl) {
    checkoutBtnEl.onclick = function(e) {
      e.preventDefault();
      window.location.href = '/checkout';
    };
  }
  // Shipping protection toggle
  var spToggle = document.getElementById('sp-toggle-input');
  if (spToggle) {
    spToggle.addEventListener('change', function() {
      fetchAndRenderCart();
    });
  }

  // Intercept Add to Cart form submissions
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form.action && form.action.indexOf('/cart/add') > -1) {
      e.preventDefault();
      var formData = new FormData(form);
      var data = {};
      formData.forEach(function(value, key) { data[key] = value; });

      // Recovery Gel is automatically included when qualifying product is in cart
      // No manual toggle check needed

      // Build cart payload - include selling_plan for subscriptions
      var cartPayload = { id: parseInt(data.id), quantity: parseInt(data.quantity || 1) };
      var hasSellingPlan = data.selling_plan && data.selling_plan !== '' && data.selling_plan !== '0';
      if (hasSellingPlan) {
        cartPayload.selling_plan = parseInt(data.selling_plan);
      }

      // Clear the entire cart before adding new items so old selections don't stack
      var addItemPromise = fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(cartPayload)
        });
      });
      addItemPromise
      .then(function(r) { return r.json(); })
      .then(function() {
        // If subscription toggle is checked, also add Recovery Gel with subscription plan
        var subToggle = document.getElementById('subscription-toggle');
        if (subToggle && subToggle.classList.contains('checked')) {
          return fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(currentCart) {
              var alreadyHasSubGel = false;
              if (currentCart && currentCart.items) {
                currentCart.items.forEach(function(ci) {
                  if (ci.selling_plan_allocation) {
                    alreadyHasSubGel = true;
                  }
                });
              }
              if (!alreadyHasSubGel) {
                return fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    id: 50071092527350,
                    quantity: 1,
                    selling_plan: 7524286710
                  })
                }).then(function(r) { return r.json(); });
              }
            });
        }
      })
      .then(function() {
        // Direct redirect to checkout — skip cart sidebar
        window.location.href = '/checkout';
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
        // Fallback: redirect to checkout
        window.location.href = '/checkout';
      });
    }
  });


  // ==========================================
  // FOOTER NEWSLETTER - KLAVIYO
  // ==========================================
  var footerNewsletterBtn = document.getElementById('footer-newsletter-btn');
  if (footerNewsletterBtn) {
    footerNewsletterBtn.addEventListener('click', function() {
      var emailInput = document.getElementById('footer-newsletter-email');
      var msgEl = document.getElementById('footer-newsletter-msg');
      var email = emailInput ? emailInput.value.trim() : '';
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!email || !emailRegex.test(email)) {
        if (msgEl) {
          msgEl.style.display = 'block';
          msgEl.style.color = '#ef4444';
          msgEl.textContent = 'Please enter a valid email address.';
        }
        return;
      }

      footerNewsletterBtn.disabled = true;
      footerNewsletterBtn.textContent = '...';

      subscribeToKlaviyo(email, KLAVIYO_NEWSLETTER_LIST_ID, 'Footer Newsletter').then(function() {
        if (msgEl) {
          msgEl.style.display = 'block';
          msgEl.style.color = '#2dd4bf';
          msgEl.textContent = 'Thank you for subscribing!';
        }
        if (emailInput) emailInput.value = '';
        footerNewsletterBtn.textContent = 'Joined!';
        setTimeout(function() {
          footerNewsletterBtn.textContent = 'Join';
          footerNewsletterBtn.disabled = false;
        }, 3000);
      }).catch(function() {
        if (msgEl) {
          msgEl.style.display = 'block';
          msgEl.style.color = '#2dd4bf';
          msgEl.textContent = 'Thank you for subscribing!';
        }
        footerNewsletterBtn.textContent = 'Join';
        footerNewsletterBtn.disabled = false;
      });
    });
  }

  // Subscription toggle
  window.toggleSubscription = function(el) {
    el.classList.toggle('checked');
    var upsell = el.closest('.subscription-upsell');
    if (el.classList.contains('checked')) {
      upsell.classList.add('active');
      el.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>';
      sessionStorage.setItem('medbed_gel_included', 'true');
    } else {
      upsell.classList.remove('active');
      el.innerHTML = '';
      sessionStorage.setItem('medbed_gel_included', 'false');
    }
    fetchAndRenderCart();
  };

  // cart gel toggle removed - gel sold as normal product


  // Gel purchase type toggle (subscription vs one-time)
  window.switchGelPurchaseType = function(type, btn) {
    // Toggle buttons
    document.querySelectorAll('.gel-toggle-btn').forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');
    
    var subPlans = document.getElementById('gel-subscription-plans');
    var otPlans = document.getElementById('gel-onetime-plans');
    var sellingPlanInput = document.getElementById('selling-plan-input');
    var form = btn.closest('form');
    var submitBtn = form ? form.querySelector('.add-to-cart-btn') : null;
    
    if (type === 'subscription') {
      if (subPlans) subPlans.style.display = '';
      if (otPlans) otPlans.style.display = 'none';
      // Re-enable selling plan
      if (sellingPlanInput) sellingPlanInput.disabled = false;
      if (submitBtn) submitBtn.innerHTML = 'Subscribe Now &mdash; <span class="cart-price-display">' + getActivePackPrice(subPlans) + '</span>';
      // Update form fields from active subscription option WITHOUT clicking
      syncFormFromActiveOption(subPlans, form, sellingPlanInput, true);
    } else {
      if (subPlans) subPlans.style.display = 'none';
      if (otPlans) otPlans.style.display = '';
      // Disable selling plan for one-time purchase
      if (sellingPlanInput) { sellingPlanInput.disabled = true; sellingPlanInput.value = ''; }
      if (submitBtn) submitBtn.innerHTML = 'Add to Cart &mdash; <span class="cart-price-display">' + getActivePackPrice(otPlans) + '</span>';
      // Update form fields from active one-time option WITHOUT clicking
      syncFormFromActiveOption(otPlans, form, null, false);
    }
  };

  // Helper: get price text from active pack option
  function getActivePackPrice(plansContainer) {
    if (!plansContainer) return '';
    var active = plansContainer.querySelector('.pack-option.active');
    if (!active) return '';
    var priceEl = active.querySelector('.pack-price');
    return priceEl ? priceEl.textContent.trim() : '';
  }

  // Helper: sync form fields from the active pack option without triggering click
  function syncFormFromActiveOption(plansContainer, form, sellingPlanInput, isSubscription) {
    if (!plansContainer || !form) return;
    var active = plansContainer.querySelector('.pack-option.active');
    if (!active) return;
    var variantId = active.dataset.variantId;
    if (variantId) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = variantId;
    }
    // Update selling plan for subscription
    // Always use the first selling plan (Shopify Subscriptions app provides one plan for all variants)
    if (isSubscription && sellingPlanInput && window.__sellingPlans && window.__sellingPlans.length > 0) {
      sellingPlanInput.value = window.__sellingPlans[0];
    }
  }
});




// === DARK SECTIONS FIX ===
function fixDarkSections() {
  var headings = document.querySelectorAll('h2');
  headings.forEach(function(h2) {
    if (h2.textContent.indexOf('Unlock the Full') > -1) {
      var section = h2.closest('section');
      if (section) {
        section.style.setProperty('background', 'linear-gradient(to bottom, #1A1A2E, #1a1a2e, #0f0f1e)', 'important');
        section.querySelectorAll('h2, h3, h4, strong').forEach(function(el) {
          el.style.setProperty('color', 'white', 'important');
        });
        section.querySelectorAll('p, span').forEach(function(el) {
          var text = el.textContent;
          if (text.indexOf('The only terahertz') > -1 || text.indexOf('Included with') > -1) {
            el.style.setProperty('color', 'rgba(255,255,255,0.5)', 'important');
          } else {
            el.style.setProperty('color', 'rgba(255,255,255,0.7)', 'important');
          }
        });
        section.querySelectorAll('h2 span').forEach(function(s) {
          s.style.setProperty('color', '#C9A96E', 'important');
        });
        section.querySelectorAll('h3 span').forEach(function(s) {
          if (s.textContent.indexOf('Science') > -1) {
            s.style.setProperty('color', '#2ABFAB', 'important');
          }
        });
        section.querySelectorAll('[style*="font-size: 0.75rem"]').forEach(function(el) {
          el.style.setProperty('color', 'rgba(255,255,255,0.5)', 'important');
        });
        section.querySelectorAll('[style*="font-size: 0.85rem"]').forEach(function(el) {
          el.style.setProperty('color', 'rgba(255,255,255,0.6)', 'important');
        });
        section.querySelectorAll('a').forEach(function(a) {
          a.style.setProperty('color', '#2ABFAB', 'important');
        });
      }
    }
  });
  
  var h3s = document.querySelectorAll('h3');
  h3s.forEach(function(h3) {
    if (h3.textContent.indexOf('Pain Relief That Fast') > -1) {
      var card = h3.closest('div[style*="background"]');
      if (card) {
        card.style.setProperty('background', 'linear-gradient(135deg, #0f172a 0%, #1a2744 100%)', 'important');
      }
    }
  });
    // Fix stats bar - find the section containing stats-section-grid
  var statsGrid = document.querySelector('.stats-section-grid');
  if (statsGrid) {
    var statsSection = statsGrid.closest('section');
    if (statsSection) {
      statsSection.style.setProperty('background', '#1a1a2e', 'important');
      // Fix the label text colors
      statsSection.querySelectorAll('p').forEach(function(p) {
        p.style.setProperty('color', 'rgba(255,255,255,0.5)', 'important');
      });
      // Fix the number colors - keep teal for numbers
      statsSection.querySelectorAll('span[style*="monospace"], span[style*="font-size: 2"], span[style*="font-size: 1.5"]').forEach(function(s) {
        s.style.setProperty('color', '#0d9488', 'important');
      });
      // Also fix any h3/h4 inside
      statsSection.querySelectorAll('h3, h4, strong').forEach(function(el) {
        el.style.setProperty('color', 'white', 'important');
      });
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', fixDarkSections);
} else {
  fixDarkSections();
}
window.addEventListener('load', fixDarkSections);
setTimeout(fixDarkSections, 500);
setTimeout(fixDarkSections, 1000);
setTimeout(fixDarkSections, 2000);
setTimeout(fixDarkSections, 3000);
setTimeout(fixDarkSections, 5000);
setTimeout(fixDarkSections, 8000);
// Also run on scroll in case sections load lazily
var darkFixScrolled = false;
window.addEventListener('scroll', function() {
  if (!darkFixScrolled) {
    fixDarkSections();
    setTimeout(fixDarkSections, 500);
  }
}, {passive: true});
// Run periodically for 15 seconds
var darkFixInterval = setInterval(fixDarkSections, 2000);
setTimeout(function() { clearInterval(darkFixInterval); darkFixScrolled = true; }, 15000);
// === END DARK SECTIONS FIX ===
